<template>
  <div>
    <div class="navbar fixed flex items-center text-color-white w-full t-0 min-h-56 z-10 shrink-0" style="background: #38342E;">
      <div class="flex-1 flex items-center" >
        <button class="h-full flex items-center pl-15 pr-10 text-15" @click="handleBack" style="width: 10%">
          <i class="sysicon-new-back" style="color: #fff;"></i>
        </button>
        <div class="font-700 title capitalize py-10 " @click="handleBack" style="width: 80%;text-align: center;" :style="{ 'font-size': fontSize + 'px' }">
          {{ title }}
        </div>
      </div>
      <slot name="right" style="width: 10%"></slot>
    </div>
    <div class="h-56"></div>
  </div>
</template>
<script setup>
import Utils from "@/utils/util";
const props = defineProps({
  title: {
    type: String,
    default: ""
  },
  back: {
    type: Boolean,
    default: true
  },
  fontSize: {
    type: Number,
    default: 16
  }
});
const emit = defineEmits(["onback"]);

function handleBack() {
  if (props.back) {
    Utils.$back();
  }
  emit("onback");
}
</script>
<style lang="scss" scoped></style>
